import { balkenAnteile } from '../../../components/immobilien/email/serienmailAnzeige';
import type { Bilanz } from '../../../lib/serienmail/fortschritt';

/** Fortschrittsbalken aus der Bilanz: gesendet grün, mit `zweifarbig` zusätzlich Fehler rot (Detailseite). */
export function Fortschrittsbalken({ bilanz, zweifarbig = false, hoehe = 6 }: { bilanz: Bilanz; zweifarbig?: boolean; hoehe?: number }) {
  const a = balkenAnteile(bilanz);
  return (
    <div role="progressbar" aria-valuemin={0} aria-valuemax={bilanz.gesamt} aria-valuenow={bilanz.gesendet} aria-label="Fortschritt"
      className="flex overflow-hidden w-full" style={{ height: hoehe, borderRadius: hoehe / 2, background: 'var(--fill2)', gap: zweifarbig && a.gesendet > 0 && a.fehler > 0 ? 2 : 0 }}>
      {a.gesendet > 0 && <span style={{ width: `${a.gesendet}%`, background: 'var(--ok)', borderRadius: hoehe / 2, transition: 'width .4s' }} />}
      {zweifarbig && a.fehler > 0 && <span style={{ width: `${a.fehler}%`, background: 'var(--bad)', borderRadius: hoehe / 2, transition: 'width .4s' }} />}
    </div>
  );
}
